var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bread-crumb',{attrs:{"location":"how to use"}}),_c('page-title',{staticClass:"mt-14"},[_c('strong',[_vm._v("How to")]),_vm._v(" Use")]),_c('page-sub-title',{staticClass:"mb-180"},[_vm._v(" 작은 디테일의 차이가 드라마틱한 변화의 기초가 됩니다.")]),_c('type-01')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }